export default "__VITE_ASSET__bQ4MPwkH__"